import * as Yup from 'yup';

export const DocumentTemplateInfoSchema = Yup.object().shape({
  codingConfig: Yup.object()
    .shape({
      code: Yup.string().required('Code requis'),
    })
    .required('Code requis'),
  label: Yup.string().required('Libellé requis'),
  document: Yup.object()
    .shape({
      typeId: Yup.string().required('Type de Document requis'),
    })
    .required('Informations du Document requises'),
});
